<template>
  <div id="medical">
    <Header></Header>
    <why-popular></why-popular>
    <medical-advantage></medical-advantage>
    <member-center></member-center>
    <our-serve></our-serve>
    <long-range></long-range>
    <cancer-inspect></cancer-inspect>
    <health-insurance></health-insurance>
    <child-img></child-img>
    <gene-detection></gene-detection>
    <more-serve></more-serve>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import WhyPopular from "../components/bestMedicalCare/WhyPopular";
import MedicalAdvantage from "../components/bestMedicalCare/MedicalAdvantage";
import MemberCenter from "../components/bestMedicalCare/MemberCenter";
import OurServe from "../components/bestMedicalCare/OurServe";
import LongRange from "../components/bestMedicalCare/LongRange";
import CancerInspect from "../components/bestMedicalCare/CancerInspect";
import HealthInsurance from "../components/bestMedicalCare/HealthInsurance";
import ChildImg from "../components/bestMedicalCare/ChildImg";
import GeneDetection from "../components/bestMedicalCare/GeneDetection";
import MoreServe from "../components/bestMedicalCare/MoreServe";
export default {
  name: "BestMedicalCare",
  components: {
    Header,
    Footer,
    WhyPopular,
    MedicalAdvantage,
    MemberCenter,
    OurServe,
    LongRange,
    CancerInspect,
    HealthInsurance,
    ChildImg,
    GeneDetection,
    MoreServe
  },
  mounted() {
    if (this.$route.query.id) {
      document.querySelector("#serve").scrollIntoView(true);
    }
  },
  methods: {
    goBack() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
